export default {
  FORMAT_DATE: 'DD/MM/YYYY'
}



// WEBPACK FOOTER //
// ./src/constants/index.js